import EnumHelper, { getToListItemDisplay, ToListItems } from '@core/helpers/enum-helper';
import { FIMenuSection } from '@core/classes/SharedEnums';

export default class FIMenuSectionEnumsHelper extends EnumHelper<FIMenuSection> {
	static toList: ToListItems<FIMenuSection>[] = [
		{
			value: FIMenuSection.Unknown,
			display: 'None',
			name: '',
			order: -1,
		},
		{
			value: FIMenuSection.Customer,
			display: 'Customer Information',
			name: 'customer',
			order: 0,
		},
		{
			value: FIMenuSection.Vehicle,
			display: 'Vehicle Information',
			name: 'vehicle',
			order: 1,
		},
		{
			value: FIMenuSection.TradeIn,
			display: 'Trade In Information',
			name: 'tradeIn',
			order: 2,
		},
		{
			value: FIMenuSection.DealDetails,
			display: 'Misc. Deal Details',
			name: 'dealDetails',
			order: undefined,
		},
		{
			value: FIMenuSection.Insurance,
			display: 'Insurance Information',
			name: 'insurance',
			order: 5,
		},
		{
			value: FIMenuSection.Purchase,
			display: 'Purchase Figures',
			name: 'purchaseFig',
			order: 4,
		},
		{
			value: FIMenuSection.Lender,
			display: 'Lender',
			name: 'lender',
			order: undefined,
		},
		{
			value: FIMenuSection.FIMenu,
			display: 'F&I Menu',
			name: 'fimenu',
			order: 6,
		},
		{
			value: FIMenuSection.DealJacket,
			display: 'Deal Jacket',
			name: 'dealJacket',
			order: 8,
		},
		{
			value: FIMenuSection.Registration,
			display: 'Registration & Titling',
			name: 'registration',
			order: 3,
		},
		{
			value: FIMenuSection.DealRecap,
			display: 'Deal Recap',
			name: 'dealRecap',
			order: 7,
		},
		{
			value: FIMenuSection.DealAudit,
			display: 'Deal Audit',
			name: 'dealAudit',
			order: 11,
		},
		{
			value: FIMenuSection.FIAdmin,
			display: 'F&I Admin',
			name: 'checklist',
			order: 9,
		},
		{
			value: FIMenuSection.Posting,
			display: 'Posting',
			name: 'accounting',
			order: 10,
		},
		{
			value: FIMenuSection.FinalizedFI,
			display: 'Finalize F&I',
			name: 'finalizeFI',
			order: 100,
		},
	];

	constructor() {
		super(FIMenuSectionEnumsHelper.toList);
	}

	static getName = (value: FIMenuSection) => this.toList.find(toListItem => toListItem.value === value)?.name;

	static getDisplay = (value: FIMenuSection) => {
		const item = this.toList.find(toListItem => toListItem.value === value);
		return getToListItemDisplay(item);
	};

	static getOrder = (value: FIMenuSection) => {
		const item = this.toList.find(toListItem => toListItem.value === value);
		return item.order;
	};
}
